import React from 'react';
import { Popup } from 'semantic-ui-react';

export default function ActionTooltip(props) {
  return (
    <Popup
      disabled={props.hidden}
      inverted={true}
      position={'bottom center'}
      trigger={props.children}
    >
      <Popup.Content>{props.content}</Popup.Content>
    </Popup>
  );
}
